import { isEmail } from 'validator';

import { validateForUI } from 'common/helpers/jsonValidator';

const loginSchema = {
  type: 'object',
  properties: {
    email: { type: 'string' },
    password: { type: 'string', minLength: 8 }
  },
  required: ['email', 'password'],
  additionalProperties: false
};

const forgotSchema = {
  type: 'object',
  properties: {
    email: { type: 'string' }
  },
  required: ['email'],
  additionalProperties: false
};

const magicLinkSchema = {
  type: 'object',
  properties: {
    email: { type: 'string' }
  },
  required: ['email'],
  additionalProperties: false
};

const resetSchema = {
  type: 'object',
  properties: {
    password: { type: 'string', minLength: 8 },
    confirmPassword: { type: 'string', minLength: 8 }
  },
  required: ['password', 'confirmPassword'],
  additionalProperties: false
};

export const validateLogin = (login) => {
  const errors = validateForUI(loginSchema, login, customValidate(login));
  return errors;
};

export const validateForgotPassword = (forgot) => {
  const errors = validateForUI(forgotSchema, forgot, customValidate(forgot));
  return errors;
};

export const validateMagicLink = (magicLink) => {
  const errors = validateForUI(
    magicLinkSchema,
    magicLink,
    customValidate(magicLink)
  );
  return errors;
};

export const validateResetPassword = (reset) => {
  const errors = validateForUI(resetSchema, reset, customValidateReset(reset));
  return errors;
};

const customValidate = (login) => {
  const errorArray = [];
  if (login.email && !isEmail(login.email)) {
    errorArray.push({
      field: 'email',
      message: 'Invalid Email'
    });
  }

  return errorArray;
};

const customValidateReset = (reset) => {
  const errorArray = [];
  if (reset.password !== reset.confirmPassword) {
    errorArray.push({
      field: 'confirmPassword',
      message: 'Confirm password must match password'
    });
  }

  return errorArray;
};
